import { BasicPermissionItem } from '../../PermissionItem'
import {
  EditPackageNumberName,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
  CreateViewEditSoftRemoveRestore,
} from '../../common'
import { CASTracker } from '../../../cimsPage/instances/cas'
import { CASStatus } from '../../../statuses/cas'

const object = 'Construction & Admin Submittal'
const page = CASTracker

const submittal = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '755CE5B9-9E9F-4A18-AE79-82F0B55DEB63',
  view: '60D0029D-01D8-4391-A145-7EE184383D87',
  edit: 'C4E3F334-7796-48EE-BBD8-4E9BB9290C88',
  removeRestore: '60CB0E80-A7FE-4BF3-97CB-5D93B4E1DF07',
})

export const CreateConstructionAdminSubmittal = submittal.Create
export const ViewConstructionAdminSubmittal = submittal.View
export const EditConstructionAdminSubmittal = submittal.Edit
export const RemoveRestoreConstructionAdminSubmittal = submittal.RemoveRestore

export const ReviseConstructionAdminSubmittal = Simple({
  id: '104B9E36-F2E4-482A-839B-0D069A0513D1',
  action: 'Revise',
  page,
  object,
})

export const RouteConstructionAdminSubmittal = Simple({
  id: '3DBCAFB5-2C8A-4952-A2FE-1B3D11F3EBC0',
  action: 'Route',
  page,
  object,
})

export const GroupReviewConstructionAdminSubmittal = new BasicPermissionItem({
  id: '260FE314-D5E7-4D8E-9309-C7EC522DE188',
  name: `Advance ${CASStatus.GroupReview.name} ${object}s`,
  action: `take action when all boxes have been checked during ${CASStatus.GroupReview.name}`,
  page,
  allowMixedCase: true,
})

export const GiveDispositionConstructionAdminSubmittal = GiveDisposition({
  id: 'A983AC16-1713-4CFD-8A57-6BA792F74EA1',
  page,
  object,
})

export const CommentOnConstructionAdminSubmittal = Simple({
  id: '7428DECA-ED63-44D5-BCC1-F6388B93C1A5',
  action: 'Comment on',
  page,
  object,
})

export const EditNumberNameConstructionAdminSubmittal = EditPackageNumberName({
  id: '08830A66-8CEF-4E04-91EF-52910DF2097D',
  page,
  object,
})

export const RevertConstructionAdminSubmittal = Revert({
  id: 'F0AC31D8-97D1-4336-BBFE-2591C4C64007',
  page,
  object,
})

export const ReviewAllConstructionAdminSubmittal = new BasicPermissionItem({
  id: '905FE4AC-8285-43A5-A320-0F78F8594A83',
  name: `${CASStatus.GroupReview.name} All ${object}s`,
  action: `check all boxes during ${CASStatus.GroupReview.name}`,
  page,
  allowMixedCase: true,
})

export const UnlockConstructionAdminSubmittal = Unlock({
  id: '2406919E-3BCB-4E8C-8C26-AB13E432D8FE',
  page,
  object,
})

/** Does not necessarily give you access to PDF Reports */
export const CreateCASPacket = Simple({
  id: '1BD8FE12-7397-49AE-904B-1FC6A1AD73AE',
  action: 'Create',
  object: `${object} Packet`,
  page,
})

export type CASTrackerPermission =
  | typeof CreateConstructionAdminSubmittal
  | typeof ViewConstructionAdminSubmittal
  | typeof EditConstructionAdminSubmittal
  | typeof RemoveRestoreConstructionAdminSubmittal
  | typeof ReviseConstructionAdminSubmittal
  | typeof RouteConstructionAdminSubmittal
  | typeof GroupReviewConstructionAdminSubmittal
  | typeof GiveDispositionConstructionAdminSubmittal
  | typeof CommentOnConstructionAdminSubmittal
  | typeof EditNumberNameConstructionAdminSubmittal
  | typeof RevertConstructionAdminSubmittal
  | typeof ReviewAllConstructionAdminSubmittal
  | typeof UnlockConstructionAdminSubmittal
  | typeof CreateCASPacket
